export const FETCH_COUNTRY_REQUEST = "FETCH_COUNTRY_REQUEST";

export const FETCH_COUNTRY_SUCCESS = "FETCH_COUNTRY_SUCCESS";

export const FETCH_COUNTRY_FAILURE = "FETCH_COUNTRY_FAILURE";
